import React from "react";
import LimitedTextField from "../../../../limited-text-field/LimitedTextField";
import styles from "./PortfolioInputFilter.module.css";

const PortfolioInputFilter = ({ filterKey, maxLength = 256, onChange, type = "TEXT", value }) => {
	const handleChange = (newValue) => {
		onChange([{ value: newValue, valueUuid: filterKey }]);
	};

	if (type === "DATE_TIME") {
		return (
			// TO REPLACE WITH DATE INPUT LATER ON
			<LimitedTextField
				className={styles.textField}
				maxLength={maxLength}
				value={value?.[0]?.value || ""}
				onChange={handleChange}
			/>
		);
	}
	return (
		<LimitedTextField
			className={styles.textField}
			maxLength={maxLength}
			value={value?.[0]?.value || ""}
			onChange={handleChange}
		/>
	);
};

export default PortfolioInputFilter;
